import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';

import { SKIP_ERROR_NOTIFICATION } from '@core/error-handling/services/http-error-notification.interceptor';
import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class PlanoEnsinoService {
  private readonly apiUrl = environment.apiUrl;
  private readonly quietContext = new HttpContext().set(SKIP_ERROR_NOTIFICATION, true);
  private readonly cache = new Map<string, boolean>();

  constructor(private http: HttpClient) {}

  getFilhosDaTurma(turmaId: number): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}/commons/turma/${turmaId}/filhos`, {
      context: this.quietContext
    });
  }

  getCamposAdicionais(etapaMatrizDisciplinaId: number): Observable<any> {
    return this.http.get<any>(
      `${this.apiUrl}/commons/plano-ensino/matriz-curricular/campos-adicionais/${etapaMatrizDisciplinaId}`,
      { context: this.quietContext }
    );
  }

  verificarDisponibilidade(turmaId: number, identificador: string): Observable<boolean> {
    const cacheKey = `${turmaId}_${identificador}`;

    if (this.cache.has(cacheKey)) {
      return of(this.cache.get(cacheKey)!);
    }

    return this.getFilhosDaTurma(turmaId).pipe(
      switchMap((filhos: any[]) => {
        const primeiroFilho = (filhos || []).find((f: any) => f?.etapaMatrizDisciplina?.id);
        if (!primeiroFilho) {
          return of(false);
        }
        return this.getCamposAdicionais(primeiroFilho.etapaMatrizDisciplina.id).pipe(
          map((campos: any) => {
            const configs: any[] = Array.isArray(campos) ? campos : [campos];
            return configs.some((c: any) => c?.identificadorConfiguracao === identificador);
          }),
          catchError(() => of(false))
        );
      }),
      tap((disponivel) => this.cache.set(cacheKey, disponivel)),
      catchError(() => {
        this.cache.set(cacheKey, false);
        return of(false);
      })
    );
  }
}
